<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <!-- <page-header :title="title" /> -->
          <!-- /Page Header -->

          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <!-- Permissions Selection -->
              <div class="card">
                <div class="card-body">
                  <form @submit.prevent="submitForm">
                    <h5 class="mb-5">
                      Role: <strong>{{ roleName }}</strong>
                    </h5>
                    <div class="form-check form-check-inline">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="selectAllPermissions"
                        v-model="selectAll"
                        @change="toggleAllPermissions"
                      />
                      <label
                        class="form-check-label"
                        for="selectAllPermissions"
                      >
                        Select All
                      </label>
                    </div>
                    <div class="row p-2">
                      <div
                        v-for="group in groupedPermissions"
                        :key="group.section"
                        class="col-md-12 mb-4"
                      >
                        <h5 class="mb-3" style="border-bottom: 1px solid #FED713;">
                          {{ group.section }}
                        </h5>
                        <div class="row">
                          <div
                            v-for="permission in group.permissions"
                            :key="permission.id"
                            class="form-check col-md-3"
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              :id="'permission-' + permission.id"
                              :value="permission.id"
                              v-model="selectedPermissions"
                            />
                            <label
                              class="form-check-label"
                              :for="'permission-' + permission.id"
                            >
                              {{ permission.name }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="btn-list mt-5">
                      <button
                        type="submit"
                        class="btn btn-primary"
                        style="float: left"
                        :disabled="isLoading"
                      >
                        Save Changes
                        <span
                          v-if="isLoading"
                          class="spinner-border spinner-border-sm ms-2"
                        ></span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";

export default {
  data() {
    return {
      title: "Role Permissions",
      isLoading: false,
      roleId: null,
      roleName: "",
      permissions: [],
      selectedPermissions: [],
      selectAll: false,
    };
  },
  watch: {
    "$route.params.roleId": {
      immediate: true,
      handler(newId) {
        this.roleId = newId;
      },
    },
  },
  computed: {
    groupedPermissions() {
      const groups = {};

      this.permissions.forEach((permission) => {
        const section = permission.section_name || "Other";
        if (!groups[section]) {
          groups[section] = [];
        }
        groups[section].push(permission);
      });

      return Object.keys(groups)
        .map((section) => ({
          section,
          permissions: groups[section],
        }));
    },
  },

  mounted() {
    this.fetchPermissions();
  },
  methods: {
    async fetchPermissions() {
      try {
        const response = await http.get(`/roles/${this.roleId}/permissions`);

        this.roleName = response.data.contents.role?.name;
        this.permissions = response.data.contents.permissions;
        this.selectedPermissions = response.data.contents.role?.permissions.map(
          (permission) => permission.id
        );

        console.log("selected permissions", this.selectedPermissions);
      } catch (error) {
        // console.error("Error fetching permissions", error);
      }
    },
    toggleAllPermissions() {
      if (this.selectAll) {
        this.selectedPermissions = this.permissions.map(
          (permission) => permission.id
        );
      } else {
        this.selectedPermissions = [];
      }
    },

    async submitForm() {
      this.isLoading = true;
      try {
        const response = await http.post(
          `/roles/${this.roleId}/permissions/sync`,
          {
            permissions: this.selectedPermissions,
          }
        );

        this.$store.dispatch("fetchRolePermissions");

        this.$toast.success(response.data.message);
      } catch (error) {
        this.$toast.error(error.response.data.message);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.present-address-header {
  background: #a2c0d3 !important;
  color: #000 !important;
}

.form-check {
  margin-bottom: 10px;
}

/* You can add additional styling as needed */
</style>
